export const cn = (
  ...classes: (string | boolean | undefined | null | Record<string, boolean>)[]
): string => {
  return classes
    .map((cls) => {
      if (typeof cls === 'string') return cls
      if (typeof cls === 'object' && cls !== null) {
        return Object.entries(cls)
          .filter(([, condition]) => condition)
          .map(([className]) => className)
          .join(' ')
      }
      return ''
    })
    .filter(Boolean)
    .join(' ')
}
